module.exports = __webpack_public_path__ + "img/pro.a7dac1af.png";